export function chart(ctx) {
    return {
        properties: {
            series:      ['#cf6679', '#82b1ff'],
            point_count: 10,
            min: 0, max: 100,
        },
        styles: {
            main: {
                ...ctx.pretty,
                grid_color: ctx.BORDER,
                type: 1,
                hdiv: 3, vdiv: 5,
                line_width: 2, point_size: 0,
            },
        },
    };
}
